import React, { useEffect, useState } from 'react';
import { database, auth } from '../firebase';


const encodeEmail = (email) => {
    return email.replace(/\./g, '_').replace(/@/g, '_');
  };
  
  const decodeEmail = (encodedEmail) => {
    let atReplaced = encodedEmail.replace('_', '@');
    return atReplaced.replace(/_/g, '.');
  };
  

  const Transactions = ({ userId }) => {
    const [transactions, setTransactions] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const transactionsPerPage = 10;
  
    useEffect(() => {
      const fetchTransactions = async () => {
        const snapshot = await database.ref('transactions').once('value');
        const data = snapshot.val();
        const transactionsArray = Object.entries(data || {}).map(([id, transaction]) => ({
          id,
          ...transaction,
        }));
        // Sort transactions by timestamp in descending order (most recent first)
        transactionsArray.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
        setTransactions(transactionsArray);
      };
  
      fetchTransactions();
    }, []);
  
    const userTransactions = transactions.filter(
      (transaction) => transaction.from === encodeEmail(userId) || transaction.to === encodeEmail(userId)
    );
  
    // Pagination logic
    const indexOfLastTransaction = currentPage * transactionsPerPage;
    const indexOfFirstTransaction = indexOfLastTransaction - transactionsPerPage;
    const currentTransactions = userTransactions.slice(indexOfFirstTransaction, indexOfLastTransaction);
  
    const paginate = (pageNumber) => setCurrentPage(pageNumber);
  
    return (<div className="money-transfer-container">
      <div className="transactions-container-tx">
        <h3>Your Transactions</h3>
        {userTransactions.length > 0 ? (
          <>
            <ul className="transactions-list-tx">
              {currentTransactions.map((transaction) => (
                <li key={transaction.id} className="transaction-item-tx">
                  <p><strong>Amount:</strong> {transaction.amount}</p>
                  <p><strong>From:</strong> {decodeEmail(transaction.from)}</p>
                  <p><strong>To:</strong> {decodeEmail(transaction.to)}</p>
                  <p><strong>Timestamp:</strong> {new Date(transaction.timestamp).toLocaleString()}</p>
                </li>
              ))}
            </ul>
            <div className="pagination-tx">
              {Array.from({ length: Math.ceil(userTransactions.length / transactionsPerPage) }, (_, i) => (
                <button
                  key={i + 1}
                  onClick={() => paginate(i + 1)}
                  className={`page-number-tx ${currentPage === i + 1 ? 'active' : ''}`}
                >
                  {i + 1}
                </button>
              ))}
            </div>
          </>
        ) : (
          <p>No transactions found.</p>
        )}
      </div></div>
    );
  };

  export default Transactions;